var _defs, _sodipodiNamedview, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaseMove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "596.79999mm",
    height: "226.75mm",
    viewBox: "0 0 596.79999 226.75",
    id: "svg4840",
    inkscapeVersion: "0.92.3 (2405546, 2018-03-11)",
    sodipodiDocname: "basemove_nobg.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4834"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 0.35,
    inkscapeCx: 503.12824,
    inkscapeCy: 335.98685,
    "inkscapeDocument-units": "mm",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "false",
    "inkscapeWindow-width": 3840,
    "inkscapeWindow-height": 2050,
    "inkscapeWindow-x": -12,
    "inkscapeWindow-y": -12,
    "inkscapeWindow-maximized": 1
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata4837"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Calque 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(0,-70.249847)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 129.3943,220.9517 c -13.60186,-9.15036 -36.460313,-9.5195 -36.460313,-9.5195 30.764923,-29.92398 17.083543,-57.00818 17.083543,-57.00818 0,0 30.78227,4.27724 24.21661,35.78936 0,0 -6.41398,-3.7965 -13.12785,-1.86606 0,0 7.48119,9.13701 8.28801,32.60438 z",
    id: "path4608",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 2.30109859,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 197.09371,262.2681 h 63.10279 l 10.84046,-12.84284 h 51.24173 c 0,11.1476 13.38224,10.29994 13.38224,10.29994 14.30691,0 17.49199,-7.16629 17.49199,-7.16629 l 3.28778,1.74663 c -6.98646,17.569 -33.5968,29.49911 -33.5968,29.49911 -8.28421,3.39245 -9.76063,10.99347 -9.76063,10.99347 H 125.79021 c -0.0508,-8.11669 -6.16458,-11.40445 -6.16458,-11.40445 -11.14789,-7.96256 -9.76046,-22.3585 -9.76046,-22.3585 l 1.13007,-20.75404 h 75.72137 z",
    id: "path3725",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccccccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 333.56888,173.59454 c 0,0 9.44313,28.62895 0.69964,56.5584 0,0 21.48405,-7.74428 48.76399,-0.79938 0,0 -26.63039,-42.96846 -49.46371,-55.75903 z",
    id: "path4532",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 270.35551,206.05016 c 0,0 7.64438,11.39164 2.69795,34.8244 0,0 31.51862,-14.48225 57.65774,-1.24906 0,0 5.89555,-24.0823 -7.29473,-37.92212 0,0 -28.39285,-4.13216 -53.06096,4.34678 z",
    id: "path4555",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4557",
    d: "m 274.65239,200.30441 c 0,0 27.89811,-10.57424 52.54084,-0.73872 0,0 4.65406,-18.85487 -5.77102,-32.34406 0,0 -25.59718,-3.16757 -46.91102,1.83162 0,0 5.08737,11.59863 0.14128,31.25116 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4557-6",
    d: "m 322.30678,164.73107 c 0,0 4.29569,-16.28351 -7.33526,-28.20288 0,0 -17.51897,-2.61147 -38.73341,0.96302 0,0 6.96091,14.54647 0.6658,28.58214 0,0 22.65888,-8.97941 45.40304,-1.34228 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 290.77547,128.28237 8.84849,0.0254 6.56523,-10.19251 -21.67414,-0.0499 z",
    id: "path4574",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 292.94197,108.18416 v 6.92104 h 4.59611 v -6.88569 z",
    id: "path4576",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 293.81944,238.36391 v 8.32389 h 5.51722 v -8.34137 z",
    id: "path4578",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4580",
    d: "m 198.72809,163.90598 c 0,0 7.64438,11.39163 2.69812,34.8244 0,0 31.51862,-14.48227 57.65755,-1.24908 0,0 5.89572,-24.08229 -7.29456,-37.92211 0,0 -28.39283,-4.13217 -53.06111,4.34679 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 203.02505,159.17465 c 0,0 28.49157,-10.57423 53.13429,-0.73872 0,0 2.61361,-17.67072 -6.36457,-32.34405 0,0 -25.59708,-3.16759 -46.91083,1.8316 0,0 5.08737,11.59864 0.14128,31.25117 z",
    id: "path4582",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 250.67951,124.12696 c 0,0 4.29569,-16.28351 -7.33543,-28.202869 0,0 -17.22201,-2.611484 -38.43661,0.963018 0,0 6.96099,14.546451 0.66579,28.582131 0,0 22.36219,-8.97941 45.10633,-1.34228 z",
    id: "path4584",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4586",
    d: "m 220.8298,92.593327 8.84857,0.02538 6.56506,-10.192512 -21.67397,-0.04991 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4588",
    d: "m 222.9963,72.495137 v 6.921027 h 4.5961 v -6.88569 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 126.82096,196.00861 c 0,0 7.00152,14.01306 2.69812,35.91254 0,0 31.51862,-14.48226 57.65758,-1.24909 0,0 5.89572,-25.17043 -7.29457,-39.01024 0,0 -24.33581,-6.23062 -53.06113,4.34679 z",
    id: "path4590",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4592",
    d: "m 131.11801,191.35098 c 0,0 27.20541,-10.57423 51.84814,-0.73872 0,0 6.03912,-19.15163 -5.07849,-32.34406 0,0 -24.61786,-4.14684 -46.91085,1.83163 0,0 5.08738,11.59862 0.14128,31.25115 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 3.08787107,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4594",
    d: "m 178.7724,156.07441 c 0,0 4.2957,-16.28351 -7.33542,-28.20288 0,0 -16.92543,-2.61147 -38.13986,0.96302 0,0 6.9609,14.54647 0.66579,28.58215 0,0 22.06542,-8.97942 44.80949,-1.34229 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 147.2411,119.32894 8.84848,0.0254 6.56515,-10.19251 -21.67406,-0.0499 z",
    id: "path4596",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 149.4076,99.230752 v 6.921018 h 4.59593 v -6.885672 z",
    id: "path4598",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4600",
    d: "m 150.77793,228.66954 v 8.3239 h 5.51731 v -8.34138 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 223.64052,242.88571 v 14.14632 h 5.51722 v -14.16381 z",
    id: "path4602",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 197.52982,202.4768 c 0,0 5.90486,18.04274 0.95843,41.4755 0,0 32.18509,-11.43264 66.38625,-2.30474 0,0 4.35026,-24.54767 -8.7836,-41.97269 0,0 -25.82804,-9.36758 -58.56108,2.80193 z",
    id: "path4604",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.02805328px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 91.991297,226.97744 9.189593,10.77404 c 0,0 -8.746463,-1.47172 -11.840833,3.55404 0,0 -2.52418,5.63866 -8.12287,6.49115 l -8.46069,-8.71429 c 0,0 5.85486,-1.19906 8.43987,-6.1109 0,0 2.70591,-6.42746 10.79493,-5.99404 z",
    id: "path4626",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 87.597237,145.48138 2.4252279,133.21503 11.328279,227.5868 61.679696,223.13532 c 0,0 34.622521,-19.19092 25.917541,-77.65394 z",
    id: "path4792",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 434.39878,108.20199 c 0,0 5.69192,27.25012 20.10136,55.08965 l -96.69697,-16.16018 46.12611,73.50393 49.31177,-9.63885 c 0,0 -13.78188,21.55822 -24.55399,57.23198 0,0 71.4195,-66.60507 169.76717,-78.07663 -97.50845,-17.62704 -164.05545,-81.9499 -164.05545,-81.9499 z",
    id: "path4794",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 4.22996044,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 389.96271,225.23129 c -22.46938,-10.52816 -48.53118,-7.36712 -48.53118,-7.36712 0,0 11.47504,-18.95066 -5.49717,-57.17703 0,0 33.39604,28.50821 54.02835,64.54415 z",
    id: "path4535",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.23835373px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 326.83064,251.8453 6.54087,4.60373 14.7843,-3.75202 6.38301,-4.48492 8.61161,0.94672 35.76237,-9.16376 -0.46953,-2.3246 z",
    id: "path4606",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cccccccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseMove);
export default __webpack_public_path__ + "static/media/baseMove.72d7016d6083ca1a27619e3631e5580f.svg";
export { ForwardRef as ReactComponent };